export const businessSectorQueryKeys = {
  all: ["business-sector"] as const,
  lists: () => [...businessSectorQueryKeys.all, "lists"],
  list: (filters: object) => [...businessSectorQueryKeys.lists(), filters],
  infiniteLists: () => [...businessSectorQueryKeys.all, "infinite-lists"],
  infiniteList: (filters?: object) => [...businessSectorQueryKeys.infiniteLists(), filters],
};
